import { CountryCode } from './type';
import type { Country } from './type';

export const unitedKingdom: Country = {
    name: 'UK',
    nameFull: 'United Kingdom',
    code: CountryCode.GB,
    displayCode: CountryCode.UK,
    combinedDisplayCode: CountryCode.UK,
    makeMethod: 'makeUnitedKingdom',
    theme: true,
    currency: '£',
    currencyName: 'GBP',
    currencyWithCountry: '£',
    maxImageSize: 4000000,  // 4MB
    imageOptions: {
        maxSize: 4000000,
        fileType: ['.tif','.png','.jpeg','.jpg','.gif']
    },
    maxGoodNumberPerClass: 1000,
    paymentMethodsImageName: 'payment-options-au.png',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_UK,
    autoSelectedInForm: true,
};
